import { render, staticRenderFns } from "./PCLink.vue?vue&type=template&id=8263cd5e&scoped=true"
import script from "./PCLink.vue?vue&type=script&lang=js"
export * from "./PCLink.vue?vue&type=script&lang=js"
import style0 from "./PCLink.vue?vue&type=style&index=0&id=8263cd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8263cd5e",
  null
  
)

export default component.exports